import React from "react";
import { formatLongToDate } from "../../helpers/Data";
import { buscarFormulariosAtivos } from "./acoes/ApiActions";
import {
  FormBox,
  FormBoxConteiner
} from "../../components/formbuilder/FormBoxConteiner";
import { View, Divider } from "react-template";

class FormsTodos extends View {
  constructor(props) {
    super(props);
    this.getFormBoxData = this.getFormBoxData.bind(this);
    this.state = { formList: [] };
  }

  componentDidMount() {
    buscarFormulariosAtivos(
      res => {
        this.setState({ formList: res.data.content });
      },
      error => {
        this.notifyError("Erro", "Erro ao buscar formulários");
      }
    );
  }

  getFormBoxData(form) {
    const dataValidade = formatLongToDate(form.dataValidade);
    const dia = dataValidade.split("/")[0];
    const mes = dataValidade.split("/")[1];
    const titulo = JSON.parse(form.formSchema).schema.title;
    const permissao = form.permissao;
    const valor = form.valorBoleto;
    const certificado = form.certificado;
    const vagas = form.limiteDeInscritos;
    return {
      id: form.id,
      dia,
      mes,
      titulo,
      permissao: permissao,
      valor,
      certificado,
      vagas
    };
  }

  renderFormBox(form) {
    const formItem = this.getFormBoxData(form);
    return (
      <FormBox
        dia={formItem.dia}
        mes={formItem.mes}
        titulo={formItem.titulo}
        permissao={formItem.permissao}
        valor={formItem.valor}
        certificado={formItem.certificado}
        n_vagas={formItem.vagas}
        url={`/responderFormulario/${form.id}`}
      />
    );
  }

  render() {
    return (
      <div id="listar-card-forms" className="p-l p-r">
        <div>
          <Divider>Formulários Disponiveis</Divider>
        </div>
        <FormBoxConteiner>
          {this.state.formList.map(form => this.renderFormBox(form))}
        </FormBoxConteiner>
      </div>
    );
  }
}

export default FormsTodos;



// WEBPACK FOOTER //
// ./src/view/inicio/FormsTodos.js